export { default as SizePicker } from './sizePicker'


// WEBPACK FOOTER //
// ./src/modules/forms/sizePicker/index.js